(function () {
  'use strict';

  function setupBundleForm(container) {
    if (!container || container.dataset.viviBundleReady === 'true') return;

    var form = container.matches('form') ? container : container.querySelector('form');
    var giftVariantId = Number(container.dataset.freeGiftVariantId || 0);
    if (!form || !giftVariantId) return;

    container.dataset.viviBundleReady = 'true';
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var productInput = form.querySelector('[name="id"]');
      var productVariantId = Number(productInput && productInput.value);
      var button = form.querySelector('[type="submit"]');
      var status = container.querySelector('[data-vivi-bundle-status]');
      if (!productVariantId || !button || button.disabled) return;

      var originalHtml = button.innerHTML;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = container.dataset.loadingLabel || 'Adding bundle...';
      if (status) status.textContent = '';

      var items = [{ id: productVariantId, quantity: 1 }];
      if (giftVariantId !== productVariantId) {
        items.push({
          id: giftVariantId,
          quantity: 1,
          properties: { '_VIVI free gift': 'Included with VIVI Pro' }
        });
      }

      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      fetch(rootPath + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (body) {
              throw new Error(body.description || body.message || 'Unable to add the bundle.');
            });
          }
          return response.json();
        })
        .then(function () {
          if (status) status.textContent = 'Bundle added. Opening your cart.';
          window.location.assign(rootPath + 'cart');
        })
        .catch(function (error) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = originalHtml;
          if (status) status.textContent = error.message || 'Unable to add the bundle. Please try again.';
        });
    });
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-vivi-bundle-form]').forEach(setupBundleForm);

    if (root.matches && root.matches('[data-vivi-bundle-form]')) {
      setupBundleForm(root);
    }
  }

  if (window.ViviBundleCart) {
    window.ViviBundleCart.init(document);
    return;
  }

  window.ViviBundleCart = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
